import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              瓜友热议
            </h2>
            <p className="text-sm text-foreground-500">
              热门爆料下的精彩评论，看看瓜友们都在聊什么
            </p>
          </div>

          <div className="space-y-4">
            {commentItems.map((item) => (
              <div
                key={item.id}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                      <span className="text-sm font-medium text-foreground-800">
                        {item.name}
                      </span>
                      <span className="text-xs text-foreground-500">
                        {item.time}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                      {item.content}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-foreground-500">
                      <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                        <i className="ri-thumb-up-line" />
                        {item.likes}
                      </button>
                      <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                        <i className="ri-chat-1-line" />
                        回复
                      </button>
                      <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                        <i className="ri-share-forward-line" />
                        分享
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}